import React, { FC } from 'react';
import AuthLayout from '@modules/auth/components/layout/AuthLayout';
import LoginForm from '@modules/auth/components/login/LoginForm';
import { Auth } from '@modules/auth/model';
import { AuthService } from '@modules/auth/service';
import Seo from '@shared/modules/seo/Seo';
import { defineRoute, redirect } from '@core/router';
import { defineAction, useAction } from '@core/router/action';
import { Effect, Function } from 'effect';
import { z } from 'zod';
import { QueryUtils } from '@shared/utils/queries';

const queries = z.object({
  referrer: z.string().catch(() => '/'),
});

const actions = {
  authenticate: defineAction({
    type: 'authenticate',
    payload: Auth.Params,
    handler: ({ request, payload }) =>
      Effect.gen(function* (_) {
        yield* _(AuthService.authenticate(payload));

        const { referrer } = yield* _(Effect.orDie(QueryUtils.parseFromRequest(request, queries)));

        yield* _(redirect(referrer));
      }),
    flashOptions: {
      error: Function.constFalse,
    },
  }),
};

const LoginPage: FC = () => {
  const [loading, authenticate, error] = useAction(actions.authenticate);

  const handleSubmit = (params: Auth.Params) => Effect.runPromiseExit(authenticate(params));

  return (
    <AuthLayout title="S'identifier">
      <Seo title="S'identifier" />
      <LoginForm loading={loading} error={error} onSubmit={handleSubmit} />
    </AuthLayout>
  );
};

const loginRoute = defineRoute({
  actions,
  element: <LoginPage />,
});

export default loginRoute;
